import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FilterSearchingBaseViewModel, Tc, TcPerfilUsuarioEnum } from 'src/app/components/core/_infrastructure/types/common';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { ConfirmationService } from 'primeng/api';
import { CertificadosFsService } from '../buscador-certificadosfs.service';

import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';
import { ConfigurationService } from '../../../../core/_infrastructure/classes/services/configuration.service';
import { CertificadosFsItemResultsViewModel, CertificadosFsItemViewModel, FilterSearchingCertificadosFsViewModel } from '../buscador-certificadosfs.types';
import { catchError, of } from 'rxjs';
import { SolicitudDocumentosExViewModel, TDocumentoSolicitudExViewModel } from '../../../solicitudes/documentos/documentosEx.types';
import { UploadedFileViewModel } from '../../../../core/components/uploader/document_uploader.types';
import { DocumentUploaderService } from '../../../../core/components/uploader/document-uploader.service';
import { DocumentosExService } from '../../../solicitudes/documentos/documentosEx.service';

@Component({
    selector: 'app-buscador-certificadosfs-wrapper',
    templateUrl: './buscador-certificadosfs-wrapper.component.html',
    styleUrls: ['./buscador-certificadosfs-wrapper.component.scss'],
})
export class BuscadorCertificadosFsWrapperComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    result: CertificadosFsItemResultsViewModel | null;
    payload?: FilterSearchingCertificadosFsViewModel;

    solicitud: SolicitudDocumentosExViewModel;
    uploadedFile: UploadedFileViewModel;

    listPais: Tc[];
    listTipoSolicitud: Tc[];
    listPuntoInspeccion: Tc[];
    listEstado: Tc[];
    listEstadoCf: Tc[];
    firstDayMonth: Date;
    lastDayMonth: Date;
    cols: any[];
    public isCollapsed = false;
    visibilitySpinnerList = false;

    constructor(
        private router: Router,
        private confirmationService: ConfirmationService,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected navMenuService: NavMenuService,
        protected exceptionHandler: ExceptionManager,
        protected configurationService: ConfigurationService,
        private buscadorCertificadosfsService: CertificadosFsService,
        private documentService: DocumentosExService,
        private uploaderService: DocumentUploaderService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.result = new CertificadosFsItemResultsViewModel();
        this.solicitud = new SolicitudDocumentosExViewModel();
        this.uploadedFile = new UploadedFileViewModel();
    }

    ngOnInit(): void {
        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.globalService.getAllPaisesExpor().subscribe(res => {
            this.listPais = res;
        });
        this.globalService.getTipoSolicitudExpor().subscribe(res => {
            this.listTipoSolicitud = res;
        });

        this.globalService.getEstadoSolicitudExpor().subscribe(res => {
            this.listEstado = res;
        });
        this.globalService.getEstadoCertificadoFitoEx().subscribe(res => {
            this.listEstadoCf = res;
        });
        this.globalService.getAllPifs().subscribe(result => {
            this.listPuntoInspeccion = result;
        });
    }

    onSearch(payload: FilterSearchingCertificadosFsViewModel): void {
        if (!payload) {
            return;
        }

        this.result = null;

        this.payload = { ...payload } as FilterSearchingCertificadosFsViewModel; // To keep a copy to be used in the lazy search (paginator)

        this.buscadorCertificadosfsService
            .postSolicitudPagedByFilter(this.payload)
            .pipe(
                catchError(error => {
                    this.catchServerError(error);
                    return of([]);
                }),
            )
            .subscribe((results: CertificadosFsItemResultsViewModel | never[]) => {
                this.result = results as CertificadosFsItemResultsViewModel;
                this.searching = true;
            });

        this.buscadorCertificadosfsService.currentFilter = payload;
    }

    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingCertificadosFsViewModel;
        this.onSearch(payload);
    }

    onReset(): void {
        this.searching = false;
        this.result = null;
        this.buscadorCertificadosfsService.clearLastSearch();
    }

    onEdit(idSolicitud: number) {
        this.router.navigate([this.router.url, 'detalleSolicitud', idSolicitud]);
    }

    onDownload(item: CertificadosFsItemViewModel) {
        this.documentService.getSolicitudDocumentos(item.IdSolicitud).subscribe(res => {
            this.solicitud = res;
            let doc: TDocumentoSolicitudExViewModel = new TDocumentoSolicitudExViewModel();
            doc = this.solicitud.TDocumentoSolicitudExCollection!.filter(r => r.EsCF == true && r.IdCopia == null)[0];

            this.uploadedFile.Guid = doc.CodigoStorage;
            this.uploadedFile.Name = doc.NombreArchivo;
            this.uploaderService.download(this.uploadedFile).subscribe(res => {
                this.OpenDownloadedFile(res);
            });
        });
    }

    private recoverLastSearch() {
        this.payload = this.buscadorCertificadosfsService.getLastSearch();
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;

        let model: FilterSearchingCertificadosFsViewModel = new FilterSearchingCertificadosFsViewModel();
        Object.assign(model, this.payload);

        this.buscadorCertificadosfsService.export(model).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    exportIsAvailable(): boolean {
        return this.result?.ResultList ? this.result?.ResultList?.length > 0 : false;
    }
}
